{
  "Find us": "Find us",
  "address-street": "Vasagatan 12, 4th floor",
  "address-postal": "111 20 Stockholm",
  "address-country": "Sweden",
  "Links": "Links",
  "Contact Support": "Contact support",
  "Changelog": "Platform updates",
  "Collegial logo": "Collegial logo",
  "Knowledge base": "Knowledge base"
}
